import _ from 'lodash';

export const getGroupsMapsByLLPACaps = llpaCaps =>
  llpaCaps.reduce((acc, { llpaTypeId, wasApplied }) => {
    if (wasApplied) {
      acc[llpaTypeId] = _.size(acc) + 1;
    }

    return acc;
  }, {});

export const getLLPACapsPreparedList = ({ llpaTypes, llpaCaps, llpaCapsGroupsMap }) =>
  llpaCaps.map(({ amount, llpaTypeId, criteriaId }) => {
    const llpaTypeName = llpaTypes.find(item => item.llpaTypeId === llpaTypeId)?.name;

    return {
      amount,
      llpaTypeId,
      name: `Cap ${llpaTypeName} LLPA`,
      groupId: llpaCapsGroupsMap[llpaTypeId] || 0,
      criteriaId,
    };
  });
